import { render, staticRenderFns } from "./InternationalCanadaCalling.vue?vue&type=template&id=67bf0612"
import script from "./InternationalCanadaCalling.vue?vue&type=script&lang=js"
export * from "./InternationalCanadaCalling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports